import React, { useContext } from "react";
import { StoreContext } from "../../Context/StoreContext";
import Activity from "./Activity";

function WhatsHappening() {
  const { state } = useContext(StoreContext);
  const {
    room: { generalRoom },
  } = state;

  return (
    <div className="w-full border border-lightGray dark:border-matteGray rounded-xl p-4 pb-0">
      <div className="flex justify-between ">
        <p className="font-bold text-lg text-darkNight dark:text-frescoWhite tracking-wide">
          What’s Happening
        </p>
      </div>
      <div className="h-81 pt-1 pb-0 overflow-y-auto custom-scrollbar">
        <Activity roomId={generalRoom?._id} />
      </div>
    </div>
  );
}

export default WhatsHappening;
